import { AccountSettings } from '@/features/account/AccountSettings'

export function AccountPage() {
  return (
    <main className="min-h-screen bg-canvas">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <AccountSettings />
      </div>
    </main>
  )
}
